import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/roomHeat.png'


const _withScopeId = n => (_pushScopeId("data-v-69403a07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor-centen-box" }
const _hoisted_2 = { class: "anchor-centen-box-top" }
const _hoisted_3 = { class: "livegif" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "anchor-centen-box-bottom" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "anchor-centen-bottom" }
const _hoisted_13 = {
  class: "ovehide",
  style: {"width":"100%","font-size":"14px","line-height":"20px"}
}
const _hoisted_14 = { style: {"font-size":"12px","height":"16px","color":"#898989"} }
const _hoisted_15 = {
  class: "ovehide",
  style: {"width":"50%"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"9.5px","height":"10px"},
  alt: ""
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "anchor-centen",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toLiveRoom($props.item)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        fit: "cover",
        "lazy-load": "",
        src: $props.item.room_cover,
        alt: ""
      }, null, 8 /* PROPS */, ["src"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($props.item.live_type == 1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "gif1",
                src: $setup.livezb,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true),
          ($props.item.live_type == 2)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "gif1",
                src: $setup.liveys,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true),
          ($props.item.live_type == 4)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "gif1",
                src: $setup.livepb,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_6))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" <div class=\"livegif\" v-else-if=\"checkZb(item) == 1\">\n                    <img class=\"gif2\" :src=\"liveqy\" alt=\"\">\n                </div>\n                <div class=\"livegif\" v-else>\n                    <img class=\"gif3\" :src=\"livejj\" alt=\"\">\n                </div> "),
        _createCommentVNode(" <img v-if=\"item.room_id\" class=\"png\" :src=\"livetj\" alt=\"\"> ")
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString($props.item.nickName || ""), 1 /* TEXT */),
        ($props.item.live_type == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('home.anchortalk')), 1 /* TEXT */))
          : ($props.item.live_type == 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('home.currentsound')), 1 /* TEXT */))
            : ($props.item.live_type == 4)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('home.movieplayback')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('home.hightqulity')), 1 /* TEXT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", _hoisted_13, _toDisplayString($props.item.room_title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString($props.item.short_name_zh), 1 /* TEXT */),
        _createElementVNode("div", null, [
          _hoisted_16,
          _createElementVNode("span", null, _toDisplayString($props.item.heat), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}